export enum IntegrationType {
    MD_UIM = 10001,
    AWS_CLOUDWATCH = 10002,
    AZURE_ALERT = 10003,
    AZURE_ALERT_CLASSIC = 10004,
    WHATAP = 10005,
    CA_UIM = 10007,
    DATADOG = 10008,
    GOOGLECLOUD = 10009,
    PROMETHEUS = 10010,
    NEWRELIC = 10011,
    DYNATRACE = 10012,
    JENNIFER5 = 10013,
    SAMS = 10014,
    GRAFANA = 10015,
    SUMO_LOGIC = 10016,
    NAGIOS = 10017,
    STANDARD = 10018,
    SAMBA = 10019,
    KAPACITOR = 10020,
    ELASTICSEARCH_WATCHER = 10021,
    EMAIL = 10022,
    AMAZON_GUARDDUTY = 10023,
    SCOUTER = 10024,
    JENNIFER4 = 10025,
    CONSUL = 10026,
    NIFFLER = 10027,
    ZENIUS = 10028,
    ZMON = 10029,
    JIRA = 10035,
    FRESHDESK = 10036,
    EVENTBRIDGE = 10037,
    JIRA_SOFTWARE = 10039,
    OPSNOW = 10038,
    IOTOPS = 10040,
    DEVOS = 10041,
    AZURE_COMMON = 10042,
    OCI = 10043,
    SENTRY_METRIC_ALERT= 10044,
    SENTRY_ISSUE_ALERT= 10045,
    SENTRY_INSTALLATION= 10046,
    SENTRY_ISSUES= 10047,
    SENTRY_COMMENTS= 10048,
    SENTRY_ERRORS= 10049,
}








// WEBPACK FOOTER //
// ./src/app/shared/enums/integration-type.enum.ts